import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Menu from "@mui/material/Menu";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, YouTube, Loyalty } from '@mui/icons-material';
import logo from '../img/logo.png'
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const pages = ["Home", "About", "Music", "Band", "Tour", "News", "Videos", "Merch", "Contact"];
const NAV_LINK_STYLE = { textDecoration: 'none', color: 'inherit' };

const Navbar = () => {
  const { isAuthenticated, logout } = useAuth0();
  const navigate = useNavigate()
  const [menuItems, setmenuItems] = React.useState(null);

  const openMenuToolTip = (event) => {
     setmenuItems(event.currentTarget);
  };

  const closeMenu = () => setmenuItems(null);

  const navigateTo = (page) => {
    navigate(page === 'Home' ? '/' : `/${page.toLowerCase()}`);
    setmenuItems(null);
  };

  const socialIcon = (link, icon) => {
    return (
      <IconButton color="inherit" href={link} target="_blank" rel="noopener noreferrer">
        {icon}
      </IconButton>
    )
  }

  return (
    <AppBar position="fixed" style={{ backgroundColor: 'rgba(0, 0, 0, 1)' }}>
      <Container maxWidth = "xxl">
        <Toolbar>
          <Typography variant="h6" component="div" align='left' sx={{ flexGrow: 1 }}>
            <img src={logo} height="53" width="70" alt="Logo" />
          </Typography>
          <Box sx = {{  display: { xs: "flex", md: "none" } }}>
            <IconButton onClick = {openMenuToolTip} color = "inherit">
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={menuItems}
              open={Boolean(menuItems)}
              onClose={closeMenu}
              color="inherit"
              sx={{ right: 0 }}
            >
              {pages.map((page) => (
                  <MenuItem key = {page} onClick = {() => navigateTo(page)} value={page}>
                    <Typography textAlign = "center"> {page} </Typography>
                  </MenuItem>
              ))}
              {isAuthenticated &&
                <MenuItem key = {'logout'} onClick = {() => logout()}>
                  <Typography textAlign = "center"> Log Out </Typography>
                </MenuItem>
              }
              {socialIcon("https://www.facebook.com/lamegenieband", <Facebook />)}
              {socialIcon("https://twitter.com/lamegenie", <Twitter />)}
              {socialIcon("https://www.instagram.com/lamegenie", <Instagram />)}
              {socialIcon("https://www.youtube.com/lamegenie", <YouTube />)}
              {socialIcon("https://lamegenie.bandcamp.com", <Loyalty />)}
            </Menu>
          </Box>
          <Box sx = {{ flexGrow: 1, display: { xs: "none", md: "flex" } }} color='inherit'>
            {pages.map((page) => (
              <Link key={page} to={page === 'Home' ? '/' : `/${page.toLowerCase()}`} style={NAV_LINK_STYLE}>
                <Button sx={{ color: "white", display: "block" }}>{page}</Button>
              </Link>
            ))}
              {isAuthenticated &&
                <MenuItem key = {'logout'} onClick = {() => logout()}>
                  <Typography textAlign = "center"> Log Out </Typography>
                </MenuItem>
              }
              {socialIcon("https://www.facebook.com/lamegenieband", <Facebook />)}
              {socialIcon("https://twitter.com/lamegenie", <Twitter />)}
              {socialIcon("https://www.instagram.com/lamegenie", <Instagram />)}
              {socialIcon("https://www.youtube.com/lamegenie", <YouTube />)}
              {socialIcon("https://lamegenie.bandcamp.com", <Loyalty />)}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Navbar;
